import { render } from "./EditDistLines.vue?vue&type=template&id=2a107987&scoped=true"
import script from "./EditDistLines.vue?vue&type=script&lang=js"
export * from "./EditDistLines.vue?vue&type=script&lang=js"

import "./EditDistLines.vue?vue&type=style&index=0&id=2a107987&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a107987"]])

export default __exports__